import { render, staticRenderFns } from "./NavPillsSection.vue?vue&type=template&id=36444e68&scoped=true&"
var script = {}
import style0 from "./NavPillsSection.vue?vue&type=style&index=0&id=36444e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36444e68",
  null
  
)

export default component.exports